import type { TenantConfig } from '@/types/TenantConfig'

const gold = 'rgb(186, 158, 94)'
const lightGold = 'rgb(198, 186, 158)'
const black = 'rgb(22, 22, 22)'

export const ammp: TenantConfig = {
  logo: 'assets/ammp/static/logo.svg',
  teaserImageSize: {
    height: 200,
  },
  componentOptions: {
    completedOrdersRoute: {
      completedImage: {
        desktop: 'assets/ammp/static/complete.jpg',
      },
      completedContentOffset: {
        desktop: '-200px',
        mobile: '-150px',
      },
    },
    stripeCreditCard: {
      fontFaceStylesheet: '/assets/oscars/static/fonts.css',
    },
    selectDate: {
      hideTodayTomorrowButtons: true,
    },
    checkoutRoute: {
      hideBackButton: true,
    },
  },
  themeOptions: {
    headerBackground: black,
    primaryColor: gold,
    secondaryColor: gold,
    cartHeaderBackgroundColor: 'white',
    cartHeaderTextColor: black,
    logoHeight: '70px',
    footerBackgroundColor: black,
    footerTextColor: 'white',
    memberLinksColor: 'white',
    memberLinksColorHover: lightGold,
  },
}
